<template>
  <div>
    <template v-if="!complete">
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 class="mt-6 text-center text-2xl font-medium text-brand-gray-900">
          Select Your Class
        </h2>
        <p class="mt-2 text-center text-sm text-brand-gray-600">
          Please select the class that you are currently taking
        </p>
        <div v-if="error !== null" class="mt-4 bg-amber-50 border-l-4 border-amber-400 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <!-- Heroicon name: solid/exclamation -->
              <svg class="h-5 w-5 text-amber-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <p class="text-sm text-amber-700 prose" v-html="error"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form class="space-y-6" action="#" method="POST" @submit.prevent="submit">
            <div v-if="!stPaulSchools"
                class="relative border border-brand-gray-300 rounded-md py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <label for="course"
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">
                Your Class
              </label>
              <div class="mt-1">
                <select v-model="form.course" id="course"
                        class="block w-full border-0 p-0 pl-3 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"
                        required>
                  <option :value="null">-- Select Your Class --</option>
                  <option v-for="course in courses" :value="course.id">{{ course.label }}</option>
                </select>
              </div>
            </div>
            <div v-else
              class="relative border border-brand-gray-300 rounded-md py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">
              <div
                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">
                Your Class
              </div>
              <div class="mt-1">
                <div class="block w-full border-0 p-0 pl-3 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm">
                  NUR206 Professional Trends in Nursing
                </div>
              </div>
            </div>
<!--            <div-->
<!--                class="relative border border-brand-gray-300 rounded-md py-2 shadow-sm focus-within:ring-1 focus-within:ring-purple-600 focus-within:border-purple-600">-->
<!--              <label for="repeating"-->
<!--                     class="absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-medium text-brand-gray-900">-->
<!--                Are you repeating this class?-->
<!--              </label>-->
<!--              <div class="mt-1">-->
<!--                <select v-model="form.repeating" id="repeating"-->
<!--                        class="block w-full border-0 p-0 pl-3 text-brand-gray-900 placeholder-brand-gray-500 focus:ring-0 sm:text-sm"-->
<!--                        required>-->
<!--                  <option :value="false">No</option>-->
<!--                  <option :value="true">Yes</option>-->
<!--                </select>-->
<!--              </div>-->
<!--            </div>-->
            <div>
              <button type="submit"
                      :disabled="submitting"
                      class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 disabled:bg-purple-300 disabled:cursor-wait">
                              <span class="flex" v-if="submitting">
                                  <svg class="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none"
                                       viewBox="0 0 24 24">
                                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                          stroke-width="4"></circle>
                                  <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                  </svg> Completing Registration
                              </span>
                <span v-else>Submit</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 class="mt-6 text-center text-2xl font-medium text-brand-gray-900">
          Registration Completed
        </h2>
        <p class="mt-2 text-center text-sm text-brand-gray-600">
          Your registration has been completed. You can now visit your
          <a href="/my-account" class="font-medium text-indigo-600 hover:text-indigo-900">My Account</a> page to view course content.
        </p>
      </div>
    </template>
  </div>
</template>

<script>

const courses = [
  {id: 'PNR206', label: 'PNR206 Medical-Surgical Nursing II'},
  {id: 'PNR207', label: 'PNR207 Transition to Practice'},
  {id: 'NUR209', label: 'NUR209 Medical-Surgical Nursing II'},
  {id: 'NUR210', label: 'NUR210 Transition to Practice'},
];
export default {
  name: 'EduAffCompleteRegistration',

  props: {
    user: Object
  },
  data() {
    return {
      complete: false,
      courses: courses,

      error: null,

      form: {
        course: null,
        // repeating: false
      },

      submitting: false,
    };
  },
  computed: {
    stPaulSchools() {
      return [1707,1708].includes(this.user.school.schoolId);
    }
  },
  methods: {
    async submit() {
      this.submitting = true;
      if(this.stPaulSchools) {
        this.form.course = 'NUR206';
      }
      try{
        await axios.post('/api/ea-students/complete-registration', {
          ...this.form
        });

        this.submitting = false;
        this.complete = true;
      }catch(e) {
        this.submitting = false;
        this.error = e.response.data;
      }
    }
  }
};
</script>

<style scoped>

</style>